<div class="app-breadcrumb">
    <div class="app-breadcrumb-item" *ngFor="let i of routerLinks; let indexVal = index; let last = last">
        <a [routerLink]="i.href" *ngIf="i.href !== ''">
            {{ i.title }}
        </a>
        <span *ngIf="i.href === ''" class="item-no-link">
            {{ i.title }}
        </span>
    </div>
</div>
